import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SidenavComponent} from './sidenav/sidenav.component';
import {SpinnerComponent} from './spinner/spinner.component';
import {TopBarComponent} from './top-bar/top-bar.component';
import {HeaderComponent} from './header/header.component';
import {MenuComponent} from './menu/menu.component';
import {PageComponent} from './pages/page/page.component';
import {MenuPanelComponent} from './menu/menu-panel/menu-panel.component';
import {MenuItemComponent} from './menu/menu-item/menu-item.component';
import {VerticalNavbarComponent} from './vertical-navbar/vertical-navbar.component';
import {BottomNavbarComponent} from './bottom-navbar/bottom-navbar.component';
import { PageListComponent } from './pages/page-list/page-list.component';
import { PageDetailComponent } from './pages/page-detail/page-detail.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SidenavComponent,
    SpinnerComponent,
    VerticalNavbarComponent,
    BottomNavbarComponent,
    MenuComponent,
    MenuPanelComponent,
    MenuItemComponent,
    TopBarComponent,
    HeaderComponent,
    BreadcrumbComponent,
    PageComponent,
    PageListComponent,
    PageDetailComponent,
  ],
  exports: [
    SidenavComponent,
    SpinnerComponent,
    VerticalNavbarComponent,
    BottomNavbarComponent,
    MenuComponent,
    MenuPanelComponent,
    MenuItemComponent,
    TopBarComponent,
    HeaderComponent,
    BreadcrumbComponent,
    PageComponent,
    PageListComponent,
    PageDetailComponent,
  ]
})
export class LayoutModule {
}
